import { Bridge, canIUse, getPlatform } from '@king-fisher/mobileweb-lib';

// 判断是否需要二次推送确认
export function needConfirmPush(devices: string[]): boolean {
  // iphone平台统一不需要二次确认
  if (getPlatform() === 'iphone') {
    return false;
  }

  // 如果支持获取二次推送确认协议，则返回根据协议的brand字段判断
  if (canIUse('getDeviceInfo')) {
    const { errCode, data } = Bridge.callNativeHandlerSync('getDeviceInfo', []);

    // 返回异常或取不到品牌则默认需要二次确认
    if (errCode !== 0 || !data.brand) {
      return true;
    }

    const currentBrand = data.brand.toUpperCase();
    // 如果设备列表包含当前设备，包含则需要二次确认
    return devices.findIndex(item => item.toUpperCase() === currentBrand) !== -1;
  }

  // 默认需要二次推送
  return true;
}

/**
 * 获取系统通知状态-falcon版本
 */
export const getNotificationStatus = (): Promise<boolean> => {
  // 如果不支持 getAppAuthorizeSetting 则直接返回默认状态
  const DEFAULT_NOTICE_STATUS = true;

  if (!canIUse('getAppAuthorizeSetting')) {
    return Promise.resolve(DEFAULT_NOTICE_STATUS);
  }

  return new Promise(resolve => {
    Bridge.callNativeHandlerAsync('getAppAuthorizeSetting', [], res => {
      console.log('获取系统通知状态', res);
      // @ts-expect-error 客户端协议返回类型未定义
      const { errCode, data } = res;
      if (errCode === 0 && data) {
        resolve(data.notificationAuthorized === 'authorized');
      } else {
        resolve(DEFAULT_NOTICE_STATUS);
      }
    });
  });
};

/**
 * 跳转到app的系统通知设置页面-falcon版本
 */
export const jumpNotificationSetting = (): boolean => {
  if (!canIUse('jumpNotificationSetting')) {
    return false;
  }

  Bridge.callNativeHandlerAsync('jumpNotificationSetting', [], () => {});
  return true;
};
